/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismTable } from '@mylighthouse/prism-ember';
import SettingsHotelAccessTablesCellsCellCta from 'lumen/components/settings/hotel-access/tables/cells/cell-cta';
import SettingsHotelAccessTablesCellsCellHotel from 'lumen/components/settings/hotel-access/tables/cells/cell-hotel';
import SettingsHotelAccessTablesCellsHeaderBenchmark from 'lumen/components/settings/hotel-access/tables/cells/header-benchmark';

import styles from './table-hotel-access.module.css';

interface SettingsHotelAccessTablesTableHotelAccessSignature {
  Args: {
    doRefresh: unknown;
    isLoading: unknown;
    message: unknown;
    model: unknown;
  };
}

export default class SettingsHotelAccessTablesTableHotelAccess extends Component<SettingsHotelAccessTablesTableHotelAccessSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const columns = [
      {
        name: this.intl.t(`settings.reports.email`),
        valuePath: 'email',
        textAlign: 'left',
        tdClassNames: 'text-data truncate',
        thClassNames:
          'settings/reports/tables/cells/text-data settings-header-space-between-text py-400',
        maxWidth: 300,
        width: 300,
        isSortable: false,
      },
      {
        tdComponent: SettingsHotelAccessTablesCellsCellHotel,
        name: this.intl.t(`useraccess_rights_tableheader_rate_market_insight`),
        thClassNames:
          'lt-column text-data settings-header-space-between-text py-400',
        valuePath: 'rateInsightAccess',
        textAlign: 'left',
        isSortable: false,
      },
      {
        name: this.intl.t(`useraccess_rights_tableheader_bi_benchmarking`),
        tooltipContent: this.intl.t(
          `useraccess_rights_tableheader_bi_benchmarking.tooltip`,
        ),
        valuePath: 'revenueInsightAccess',
        textAlign: 'left',
        tdComponent: SettingsHotelAccessTablesCellsCellHotel,
        thClassNames: 'text-data settings-header-space-between-text py-400',
        thComponent: SettingsHotelAccessTablesCellsHeaderBenchmark,
        isSortable: false,
      },
      {
        // CTA column
        name: ``,
        maxWidth: 75,
        width: 75,
        tdComponent: SettingsHotelAccessTablesCellsCellCta,
        valuePath: 'cta',
        columnKey: 'cta',
        isSortable: false,
        thClassNames: 'py-400',
      },
    ];

    return columns;
  }

  // eslint-disable-next-line ember/use-brace-expansion
  @computed('args.doRefresh', 'args.model.[]')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.model.map((row) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        row.doRefresh = this.args.doRefresh;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return row;
      }) ?? []
    );
  }

  <template>
    <div class="h-full overflow-y-auto">
      <PrismTable
        {{! @glint-expect-error: Incorrect type }}
        @columns={{this.columns}}
        @fillMode="equal-column"
        {{! @glint-expect-error: Incorrect type }}
        @isLoading={{@isLoading}}
        @removeTableBorder={{true}}
        @rows={{this.rows}}
        @widthConstraint="eq-container"
      />
    </div>
    {{! @glint-expect-error: Incorrect type }}
    {{#if @message.hasMessage}}
      <div class={{styles.message-overlay}}>
        <div class={{styles.message-wrapper}}>
          {{! @glint-expect-error: Incorrect type }}
          {{@message.message}}
        </div>
      </div>
    {{/if}}
  </template>
}
